import { cn } from '@/common-utils/libraries/tailwind/utils';
import PropTypes from 'prop-types';

/**
 *
 * @param root0
 * @param root0.className
 * @returns {JSX} Skeleton
 */
function Skeleton({
  className,
  ...props
}) {
  return (<div className={cn('animate-pulse rounded-md bg-muted', className)} {...props} />);
}

Skeleton.propTypes = {
  className: PropTypes.string
};

export { Skeleton };
